import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { SectionBarComponent } from './sectionbar.component';
import { AuditModule } from '../audit/audit.module';
import { NgModule } from '@angular/core';
import { MatInputModule, MatIconModule, MatButtonModule, MatSelectModule, MatTooltipModule, MatTabsModule, MatFormFieldModule } from '@angular/material';
// import { OfficeService } from 'src/app/modules/security/Office/shared/office.service';
//import { UsuarioPerfilService } from '../../modulos/seguridad/perfil/usuario/shared/usuario.service';

@NgModule({
    imports: [
         BrowserAnimationsModule, FormsModule, AuditModule,
         MatInputModule, MatIconModule, MatButtonModule, MatSelectModule, MatTooltipModule, MatTabsModule,
         MatFormFieldModule
    ],
    exports: [SectionBarComponent],
    declarations: [SectionBarComponent],
    providers: []
      //UsuarioPerfilService

})
export class SectionBarModule {
}
